import format from 'date-fns/format';

const DEFAULT_DATE_FORMAT = 'MM/dd/yyyy hh:mm:ss a';

export const formatDateTime = (date?: Date | string, pattern?: string) =>
  date && format(new Date(date), pattern || DEFAULT_DATE_FORMAT);
